export default __webpack_public_path__ + "3420ca6bbbb1156697d5fd8e15134139.png";